import React from 'react';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { CardOrder } from 'app/model/CardOrder';
import { CardProduct } from 'app/model/product/CardProduct';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { FormatUtils } from 'app/utils/FormatUtils';

export interface DefaultProductDetailProps {
    cardProduct: CardProduct;

    order: CardOrder;
}

export const DefaultProductDetails = ({
    cardProduct,
    order,
}: DefaultProductDetailProps) => {
    const insurance = cardProduct.insurance.find(
        ({ code }) => code === order.insuranceProductCode,
    );

    return (
        <>
            <FieldSet
                className={'productDetailsFieldSet'}
                fieldsProps={[
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: `до ${FormatUtils.toIntegerString(
                            cardProduct.maxAmount,
                        )} ${cardProduct.currency}`,
                        isVisible: !order.amount,
                    },
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: (
                            <span className={WEB_VISOR_HIDE}>
                                {!!order.amount &&
                                    FormatUtils.toIntegerString(
                                        order.amount,
                                    )}{' '}
                                {order.currency}
                            </span>
                        ),
                        isVisible: !!order.amount,
                    },
                    {
                        className: 'rate',
                        title: 'Ставка по кредиту',
                        value: `${FormatUtils.toPercentString(
                            cardProduct.rate,
                        )} %`,
                    },
                    //https://projects.alfabank.by/browse/CC2C-199
                    // {
                    //     className: 'grantTerm',
                    //     title: 'Срок предоставления',
                    //     value: cardProduct.grantTerm,
                    // }
                    {
                        className: 'insurance',
                        title: 'Страховой взнос',
                        value: `${
                            !!insurance?.amount &&
                            FormatUtils.toIntegerString(insurance?.amount)
                        } ${insurance?.currency}`,
                        isVisible: !!insurance,
                    },
                ]}
            />
            <ul className={'creditAdvantages'}>
                <li>Кредит предоставляется на весь срок действия карты</li>
                <li>Можно оформить страхование медицинских расходов</li>
                <li>Бесплатная страховка по карточке в ПОДАРОК!</li>
            </ul>
        </>
    );
};
